// Read from environment variable
const backendUrl = import.meta.env.VITE_BACKEND_URL;

// In development with Vite proxy, we use relative URLs
// In production, we need the full URL
export const API_BASE_URL = backendUrl ? `${backendUrl}/api/v1` : '/api/v1';
